import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../layout/index.vue'
import { getRootPath } from '../utils/loginEntry'

Vue.use(VueRouter)

export const constantRoutes = [
  {
    path: '/welcome',
    alias: '/portal/login',
    name: 'Welcome',
    hidden: true,
    component: () => import('../views/welcome/index.vue'),
    meta: { title: 'LabelCheap', public: true }
  },
  {
    path: '/login',
    name: 'Login',
    hidden: true,
    component: () => import('../views/login/index.vue')
  },
  {
    path: '/portal/sign-in',
    name: 'PortalLogin',
    hidden: true,
    component: () => import('../views/login/index.vue')
  },
  {
    path: '/',
    redirect: getRootPath,
    component: Layout,
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('../views/home/index.vue'),
        meta: {
          title: '首页',
          icon: 'home'
        }
      },
      {
        path: '/analysis',
        name: 'Analysis',
        hidden: true,
        component: () => import('../views/home/components/analysis/index.vue'),
        meta: {
          title: '数据分析',
          icon: 'analysis',
          activeMenu: '/home'
        }
      }
    ]
  },
  {
    path: '/usage-guide',
    name: 'CustomerGuideLayout',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        name: 'CustomerUsageGuide',
        component: () => import('../views/transport/UsageGuide.vue'),
        meta: { title: '使用说明', icon: 'documentation' }
      }
    ]
  },
  {
    path: '/referrals',
    name: 'ReferralLayout',
    component: Layout,
    hidden: true,
    children: [{ path: '', name: 'Referrals', component: () => import('../views/transport/Referrals.vue'), meta: { title: '推广返利', icon: 'peoples', adminOnly: true } }]
  },
  // Dashboard links must remain reachable while role-based menus are loading
  // (or when an older database has not yet created a newer menu row). The
  // transport view still performs role checks and API authorization on the
  // server, so these hidden routes do not grant additional permissions.
  {
    path: '/transport',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'tr-create',
        name: 'TransportTrCreateFallback',
        component: () => import('../views/transport/index.vue'),
        meta: { title: '创建订单', icon: 'form' }
      },
      {
        path: 'tr-products',
        name: 'TransportTrProductsFallback',
        component: () => import('../views/transport/index.vue'),
        meta: { title: '产品列表', icon: 'shopping' }
      },
      {
        path: 'tr-orders',
        name: 'TransportTrOrdersFallback',
        component: () => import('../views/transport/index.vue'),
        meta: { title: '订单管理', icon: 'shopping' }
      },
      {
        path: 'api-failure-logs',
        name: 'TransportApiFailureLogs',
        component: () => import('../views/transport/ApiFailureLogs.vue'),
        meta: { title: '接口错误日志', icon: 'warning', activeMenu: '/home' }
      },
      {
        path: 'tr-claims',
        name: 'TransportTrClaimsFallback',
        component: () => import('../views/transport/index.vue'),
        meta: { title: '索赔管理', icon: 'form' }
      },
      {
        path: 'tr-disputes',
        name: 'TransportTrDisputesFallback',
        component: () => import('../views/transport/Dispute.vue'),
        meta: { title: '争议管理', icon: 'form' }
      },
      {
        path: 'fin-accounts',
        name: 'TransportFinAccountsFallback',
        component: () => import('../views/transport/index.vue'),
        meta: {
          title: '资金账户',
          icon: 'money'
        }
      },
      {
        path: 'fin-recharge',
        name: 'TransportFinRechargeFallback',
        component: () => import('../views/transport/index.vue'),
        meta: { title: '充值登记', icon: 'money' }
      },
      {
        path: 'fin-recharge-records',
        name: 'TransportFinRechargeRecordsFallback',
        component: () => import('../views/transport/index.vue'),
        meta: { title: '充值记录', icon: 'money' }
      },
      {
        path: 'fin-deposits',
        name: 'TransportFinDepositsFallback',
        component: () => import('../views/transport/index.vue'),
        meta: { title: '保证金管理', icon: 'money' }
      },
      {
        path: 'fin-deposit-list',
        name: 'TransportDepositListFallback',
        component: () => import('../views/transport/DepositList.vue'),
        meta: { title: '押金列表', icon: 'money' }
      },
      {
        path: 'fin-ledger',
        name: 'TransportFinLedgerFallback',
        component: () => import('../views/transport/index.vue'),
        meta: { title: '费用明细', icon: 'money' }
      },
      {
        path: 'fin-profit',
        name: 'TransportFinProfitFallback',
        component: () => import('../views/transport/index.vue'),
        meta: { title: '利润统计', icon: 'data-analysis' }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    hidden: true,
    redirect: 'noRedirect',
    children: [
      {
        path: 'profile',
        component: () => import('@/views/system/profile/index'),
        name: 'Profile',
        meta: {
          title: '个人中心',
          icon: 'user',
          activeMenu: '/home'
        }
      }
    ]
  },
  {
    path: '/404',
    component: () => import('../views/system/error/404/index.vue'),
    hidden: true,
    meta: {
      title: '404 Not Found'
    }
  },
  {
    path: '/401',
    component: () => import('../views/system/error/401/index.vue'),
    hidden: true
  }
]

// 获取原型对象push函数
const originalPush = VueRouter.prototype.push
// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace

/**
 * 修改原型对象中的push函数
 *
 * @param {*} location 当前要跳转路径的对象
 * @returns
 */
VueRouter.prototype.push = function push (location) {
  // this指向当前VueRouter的实例对象
  return originalPush.call(this, location).catch(err => err)
}

/**
 * 修改原型对象中的replace函数
 *
 * @param {*} location 当前要跳转路径的对象
 * @returns
 */
VueRouter.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch(err => err)
}

const createRouter = () => new VueRouter({
  mode: 'history',
  // 路由切换时回到最顶端
  scrollBehavior: () => ({ y: 0 }),
  base: process.env.BASE_URL,
  routes: constantRoutes
})

// 新建路由
const router = createRouter()
// 重置路由函数 export
export function resetRouter () {
  const newRouter = createRouter()
  // 替换成新的空路由
  router.matcher = newRouter.matcher
}

export default router
